import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleSheetsLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 26,
	viewBox: "0 0 19 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_10527_12123)",
		children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_10527_12123",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 19,
				height: 26,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M11.7943 0.37207H2.04391C1.09754 0.37207 0.323242 1.14698 0.323242 2.09409V23.9063C0.323242 24.8534 1.09754 25.6283 2.04391 25.6283H16.9563C17.9027 25.6283 18.677 24.8534 18.677 23.9063V7.26013L11.7943 0.37207Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_10527_12123)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M11.7943 0.37207H2.04391C1.09754 0.37207 0.323242 1.14698 0.323242 2.09409V23.9063C0.323242 24.8534 1.09754 25.6283 2.04391 25.6283H16.9563C17.9027 25.6283 18.677 24.8534 18.677 23.9063V7.26013L14.6621 4.39011L11.7943 0.37207Z",
					fill: "#0F9D58"
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask1_10527_12123",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 19,
				height: 26,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M11.7943 0.37207H2.04391C1.09754 0.37207 0.323242 1.14698 0.323242 2.09409V23.9063C0.323242 24.8534 1.09754 25.6283 2.04391 25.6283H16.9563C17.9027 25.6283 18.677 24.8534 18.677 23.9063V7.26013L11.7943 0.37207Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask1_10527_12123)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M4.91211 12.7129V21.036H14.089V12.7129H4.91211ZM8.92699 19.888H6.05922V18.4529H8.92699V19.888ZM8.92699 17.5919H6.05922V16.1569H8.92699V17.5919ZM8.92699 15.2959H6.05922V13.8609H8.92699V15.2959ZM12.9419 19.888H10.0741V18.4529H12.9419V19.888ZM12.9419 17.5919H10.0741V16.1569H12.9419V17.5919ZM12.9419 15.2959H10.0741V13.8609H12.9419V15.2959Z",
					fill: "#F1F1F1"
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask2_10527_12123",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 19,
				height: 26,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M11.7943 0.37207H2.04391C1.09754 0.37207 0.323242 1.14698 0.323242 2.09409V23.9063C0.323242 24.8534 1.09754 25.6283 2.04391 25.6283H16.9563C17.9027 25.6283 18.677 24.8534 18.677 23.9063V7.26013L11.7943 0.37207Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask2_10527_12123)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M12.2979 6.75684L18.6772 13.1398V7.26052L12.2979 6.75684Z",
					fill: "url(#paint0_linear_10527_12123)"
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask3_10527_12123",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 19,
				height: 26,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M11.7943 0.37207H2.04391C1.09754 0.37207 0.323242 1.14698 0.323242 2.09409V23.9063C0.323242 24.8534 1.09754 25.6283 2.04391 25.6283H16.9563C17.9027 25.6283 18.677 24.8534 18.677 23.9063V7.26013L11.7943 0.37207Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask3_10527_12123)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M11.7939 0.37207V5.53812C11.7939 6.48953 12.5639 7.26013 13.5146 7.26013H18.6766L11.7939 0.37207Z",
					fill: "#87CEAC"
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask4_10527_12123",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 19,
				height: 26,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M11.7943 0.37207H2.04391C1.09754 0.37207 0.323242 1.14698 0.323242 2.09409V23.9063C0.323242 24.8534 1.09754 25.6283 2.04391 25.6283H16.9563C17.9027 25.6283 18.677 24.8534 18.677 23.9063V7.26013L11.7943 0.37207Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask4_10527_12123)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M2.04391 0.37207C1.09754 0.37207 0.323242 1.14698 0.323242 2.09409V2.23759C0.323242 1.29048 1.09754 0.515572 2.04391 0.515572H11.7943V0.37207H2.04391Z",
					fill: "white",
					fillOpacity: .2
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask5_10527_12123",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 19,
				height: 26,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M11.7943 0.37207H2.04391C1.09754 0.37207 0.323242 1.14698 0.323242 2.09409V23.9063C0.323242 24.8534 1.09754 25.6283 2.04391 25.6283H16.9563C17.9027 25.6283 18.677 24.8534 18.677 23.9063V7.26013L11.7943 0.37207Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask5_10527_12123)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M16.9563 25.4847H2.04391C1.09754 25.4847 0.323242 24.7098 0.323242 23.7627V23.9062C0.323242 24.8533 1.09754 25.6282 2.04391 25.6282H16.9563C17.9027 25.6282 18.677 24.8533 18.677 23.9062V23.7627C18.677 24.7098 17.9027 25.4847 16.9563 25.4847Z",
					fill: "#263238",
					fillOpacity: .2
				})
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask6_10527_12123",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 19,
				height: 26,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M11.7943 0.37207H2.04391C1.09754 0.37207 0.323242 1.14698 0.323242 2.09409V23.9063C0.323242 24.8534 1.09754 25.6283 2.04391 25.6283H16.9563C17.9027 25.6283 18.677 24.8534 18.677 23.9063V7.26013L11.7943 0.37207Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask6_10527_12123)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M13.5146 7.2601C12.5639 7.2601 11.7939 6.4895 11.7939 5.53809V5.68159C11.7939 6.633 12.5639 7.4036 13.5146 7.4036H18.6766V7.2601H13.5146Z",
					fill: "#263238",
					fillOpacity: .1
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.7943 0.37207H2.04391C1.09754 0.37207 0.323242 1.14698 0.323242 2.09409V23.9063C0.323242 24.8534 1.09754 25.6283 2.04391 25.6283H16.9563C17.9027 25.6283 18.677 24.8534 18.677 23.9063V7.26013L11.7943 0.37207Z",
				fill: "url(#paint1_radial_10527_12123)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_10527_12123",
			x1: 331.3,
			y1: 61.5614,
			x2: 331.3,
			y2: 645.139,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#263238",
				stopOpacity: .2
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#263238",
				stopOpacity: .02
			})]
		}),
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint1_radial_10527_12123",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(58.4688 50.2895) scale(2959.51 2961.84)",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "white",
				stopOpacity: .1
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "white",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_10527_12123",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 19,
				height: 26,
				fill: "white"
			})
		})
	] })]
});
export default SvgGoogleSheetsLogo;
